module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/client/create-client/create-client.component.css
// module id = ./src/app/auth/client/create-client/create-client.component.css
// module chunks = main